export default __webpack_public_path__ + "static/media/appbar-logo.15da69f2.svg";